import React from "react";
import s from './Table.module.css'
// import TableTbodyContainer from "./TableTbody/TableTbodyContainer";
// import TableTheadContainer from "./TableThead/TableTheadContainer";
import {Box, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {useSelector} from "react-redux";
import {TableContent} from "./TableContent/TableContent";

const useStyles = makeStyles(theme => ({
    noItemWrapper: {
        display: `flex`,
        height: `100%`,
        width: `100%`,
        alignItems: `center`,
        justifyContent: `center`,
        '& > .MuiTypography-root': {
            fontSize: `40px`,
        }
    }
}))

export const Table = () => {
    const classes = useStyles();
    const {contentData} = useSelector(state => state);

    if (contentData.isActivePromosScreen) {
        const data = contentData.isPrintListOpened ? contentData.printListDataForPromos : contentData.data;
        if (data.length === 0) {
            return (
                <Box className={classes.noItemWrapper}>
                    <Typography color={`grey.400`}>
                        {contentData.isPrintListOpened ? `אין שלטים להדפסה` : `אין תוצאות חיפוש`}
                    </Typography>
                </Box>
            )
        }
        return (
            <div className={s.tableWrapperRegPrices}>
                <div className={s.tableRegPrices}>
                    {/*<TableHeadersContainer/>*/}
                    <TableContent/>
                </div>
            </div>

            // <div className={s.tableWrapper}>
            //     <table className={s.table}>
            //         <TableTheadContainer/>
            //         <TableTbodyContainer/>
            //     </table>
            // </div>
        )
    } else {
        const data = contentData.isPrintListOpened ? contentData.printListDataForItems : contentData.dataForRegPrices;
        if (data.length === 0) {
            return (
                <Box className={classes.noItemWrapper}>
                    <Typography color={`grey.400`}>
                        {contentData.isPrintListOpened ? `אין שלטים להדפסה` : `אין תוצאות חיפוש`}
                    </Typography>
                </Box>
            )
        }
        return (
            <div className={s.tableWrapperRegPrices}>
                <div className={s.tableRegPrices}>
                    {/*<TableHeadersContainer/>*/}
                    <TableContent/>
                </div>
            </div>

        )
    }
};


